import { render, staticRenderFns } from "./EquipesDataTable.vue?vue&type=template&id=b5f13fca&scoped=true"
import script from "./EquipesDataTable.vue?vue&type=script&lang=js"
export * from "./EquipesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f13fca",
  null
  
)

export default component.exports